import store from "../../../../../store";
import { has } from "../../../../../utils/menu-context";

export const commonInputPropField = ({ disabledStatuses, disabledRequestTypes }) => ({ modelRef, initialModel }) => {
    let enabled = undefined;
    if (disabledStatuses?.includes(initialModel.refStatus?.key) || disabledRequestTypes?.includes(modelRef.refRequestType?.key)) {
        enabled = false;
    }
    return { disabled: enabled !== undefined ? !enabled : undefined };
};

export const createConditionAction = () => {
    return {
        canEdit: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canEdit" }) || record.isActive === false) {
                return false;
            }
            if (has({ menuContext, key: "forRequest" })) {
                if (["draft", "reEditAuthority"].includes(record?.refStatus?.key)) {
                    result = true || result;
                }
            }
            if (has({ menuContext, key: "forApprove" })) {
                if (["waitReceive", "waitApprove"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        },
        canArchive: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canArchive" }) || record.isActive === false) return false;
            if (["draft"].includes(record.refStatus?.key)) {
                result = true || result;
            }
            return result;
        },
        canDelete: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canDelete" }) || record.isActive === false) return false;
            if (["draft"].includes(record.refStatus?.key)) {
                result = true || result;
            }
            return result;
        },
        canWaitApprove: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (has({ menuContext, key: "forRequest" }) || record.isOfficerCreate) {
                if ([null, "draft", "reEditAuthority"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        },
        canApprove: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            const userInfo = store.state.resource.auth.info?.user;
            if (has({ menuContext, key: "forApprove" })) {
                if (["waitApprove"].includes(record.refStatus?.key)) {
                    if (record.refToApproveBy?.username === userInfo.username) {
                        result = true || result;
                    }
                }
            }
            return result;
        },
        canReStatus: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (has({ menuContext, key: "forRequest" })) {
                if (["waitApprove"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        }
    };
};

export const createConditionForm = ({ dataKey }) => {
    const prefixRegExp = dataKey ? `${dataKey}\\.` : "";
    return [
        {
            check: ({ field }) => {
                return [
                    "refRequestType",
                    "refSamplingAnalysisTemp.refSendSampling",
                    "refSamplingAnalysisTemp.refDepartment",
                    "refSamplingAnalysisTemp.refAnalysisDepartment",
                    "refSamplingAnalysisTemp.resultRemark",
                ].includes(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitApprove",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: ["4"]
            })
        },
        {
            check: ({ field }) => {
                return ["requestCode"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return !!modelRef.requestCode
            },
        },
        {
            check: ({ field }) => {
                return ["refSamplingAnalysisTemp.approveCode"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return !!modelRef.refSamplingAnalysisTemp?.approveCode
            },
            inputPropField: () => {
                return true;
            }
        },
        {
            check: ({ field }) => {
                return ["refSamplingAnalysis"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return ["4"].includes(modelRef.refRequestType?.key);
            },
            inputPropField: ({ modelRef, initialModel }) => {
                const common = commonInputPropField({
                    disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                    disabledRequestTypes: []
                })({ modelRef, initialModel });
                return common;
            }
        },
        {
            check: ({ field }) => {
                return ["lastStatus.forRequestRemark.0.remark"].includes(field?.key);
            },
            inputPropField: ({ modelRef, initialModel }) => {
                const common = commonInputPropField({
                    disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                    disabledRequestTypes: []
                })({ modelRef, initialModel });
                return common;
            }
        },
        {
            check: ({ field }) => {
                return ["lastStatus.forApproveRemark.0.remark"].includes(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    undefined,
                    "draft",
                    "waitResponseCustoms",
                    "reEditOfficer",
                    "reEditAuthority",
                    "reEditCustoms",
                    "waitPayment",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: []
            })
        },
        {
            check: ({ field }) => {
                const regExps = [
                    new RegExp(`^refSamplingAnalysisTemp\\.products\\.[^\\.]+\\.(refTopic)$`, "g"),
                    new RegExp(`^refSamplingAnalysisTemp\\.products\\.[^\\.]+\\.(refMethod)$`, "g"),
                    new RegExp(`^refSamplingAnalysisTemp\\.products\\.[^\\.]+\\.(testResult)$`, "g"),
                    new RegExp(`^refSamplingAnalysisTemp\\.products\\.[^\\.]+\\.(criterionResult)$`, "g"),
                    new RegExp(`^refSamplingAnalysisTemp\\.products\\.[^\\.]+\\.(topicUnit)$`, "g"),
                    new RegExp(`^refSamplingAnalysisTemp\\.products\\.[^\\.]+\\.(refResult)$`, "g"),
                    new RegExp(`^refSamplingAnalysisTemp\\.products\\.[^\\.]+\\.(analysisNo)$`, "g"),
                    new RegExp(`^refSamplingAnalysisTemp\\.products\\.[^\\.]+\\.(receiveDate)$`, "g"),
                    new RegExp(`^refSamplingAnalysisTemp\\.products\\.[^\\.]+\\.(analysisDate)$`, "g"),
                    new RegExp(`^refSamplingAnalysisTemp\\.products\\.[^\\.]+\\.(size)$`, "g"),
                    new RegExp(`^refSamplingAnalysisTemp\\.products\\.[^\\.]+\\.(refSizeUnit)$`, "g"),
                    new RegExp(`^refSamplingAnalysisTemp\\.products\\.[^\\.]+\\.(qty)$`, "g"),
                    new RegExp(`^refSamplingAnalysisTemp\\.products\\.[^\\.]+\\.(refQtyUnit)$`, "g"),
                ];
                return regExps.some(d => d.test(field?.key));
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitRelease",
                    "waitApprove",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: ["4"]
            })
        },
        {
            check: ({ field }) => {
                return new RegExp(
                    `^${prefixRegExp}refSamplingAnalysisTemp\\.attachments\\.[^\\.]+\\.(documentName|(attribute\\.(documentNo|documentDate|documentExpiredDate))|size)$`,
                    "g"
                ).test(field?.key);
            },
            inputPropField: ({ modelRef, initialModel, record }) => {
                const common = commonInputPropField({
                    disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                    disabledRequestTypes: []
                })({ modelRef, initialModel });
                if (common.disabled !== true) {
                    if (["3", "4"].includes(modelRef.refRequestType?.key)) {
                        if (record?.attribute?.isDisabledDocumentName) {
                            common.disabled = true;
                        }
                    }
                }
                return common;
            }
        },
        {
            check: ({ componentKey }) => {
                return ["AttachmentInlineList"].includes(componentKey);
            },
            inputPropField: ({ props, initialModel }) => {
                const { viewOnly } = props;
                let canCreate = false;
                let canDelete = false;
                if ([undefined, "draft", "reEditOfficer", "reEditAuthority"].includes(initialModel.refStatus?.key)) {
                    canCreate = !viewOnly || canCreate;
                    canDelete = !viewOnly || canDelete;
                }
                return { canCreate, canDelete };
            }
        }
    ];
};
